import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class FileDownloadService {

	constructor() {
	}

	downloadFile(blob: Blob, filename: string) {
		const a = document.createElement('a');
		a.download = filename;
		a.href = window.URL.createObjectURL(blob);
		a.click();
		window.URL.revokeObjectURL(a.href);
		a.remove();
	}

	getFileName(contentDisposition: string | null): string | null {
		
		if (!contentDisposition) return null;

		const match = contentDisposition.match(/filename\*?=(?:UTF-8'')?["']?([^;"']+)/);

		return match?.[1] ? decodeURIComponent(match[1]) : null;
	}

	// replacement is used as the fallback for an input that sanitises to empty string
	toSafeFileName(input: string, replacement = '_'): string {
		return input
			.replace(/[<>:"/\\|?*\u0000-\u001F]/g, replacement)
			.replace(/^[\s.]+|[\s.]+$/g, '')
			.replace(/^(CON|PRN|AUX|NUL|COM[1-9]|LPT[1-9])$/i, name => name + replacement)
			.slice(0, 255) || replacement;
	}
}